import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "../translation/";
import { getSearchTerm } from "../../state/modules/search";
import { SEARCH_TERM_ID } from "../constants";
import styles from "./SearchTerm.css";
import SuggestedTerm from "./SuggestedTerm";

export const SearchTerm = ({ searchTerm, formatTranslation }) => {
  if (!searchTerm) {
    return null;
  }

  return (
    <div id={SEARCH_TERM_ID} className={styles.wrapper}>
      <p className={styles.text}>
        {formatTranslation("plp_web_suggested_term_suggestion_title")}
      </p>
      <p className={styles.searchTerm}>
        {formatTranslation("plp_web_suggested_term_user_search_term", {
          searchTerm
        })}
      </p>
      <SuggestedTerm />
    </div>
  );
};

SearchTerm.propTypes = {
  searchTerm: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired
};

SearchTerm.displayName = "SearchTerm";

function mapStateToProps(state) {
  return {
    searchTerm: getSearchTerm(state)
  };
}

export default connect(mapStateToProps)(withTranslation(SearchTerm));
